<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'huandengandlist',
})
</script>
<template>
    <div v-if="data" >
       <defaultsection :data="data" style="margin-bottom: 50px;"></defaultsection>
      <a-row :gutter="[30,30]">
        <a-col  :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
            <div class="content-box padding "  :href="item.url" >
              <div class="line  bg-primary"></div>
                  <h3 class="flex justify-center align-center">
                    <img :src="addip(item.icon)" v-if="item.icon" class="box-lg margin-right"  />
                    <span  class="flex1">{{ item.name }}</span>
                    <a :href="item.url"><ArrowRightOutlined /></a>
                  </h3>
                  <h5 :style="item.icon?{paddingLeft:'55px'}:{}" v-if="item.sub">{{ item.sub }}</h5>
            </div>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="huandengandlist">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
import huandengmini from './huandengmini.vue'
import {ArrowRightOutlined} from '@ant-design/icons-vue'
import defaultsection from './default.vue'
defineProps({
  data:Object
})
</script>
<style lang="less">
@import '@/style/main.less';
  .huandengandlist{
    .content-box{
      position: relative;
      .line{position: absolute;height:100%;transition: all linear .3s;z-index: 0;left:0;top:0;background-color: @primary;border-left: 4px solid @primary;width:0;}
      .anticon {opacity: .5;cursor: pointer;}
    }
    .content-box:hover{
      .line{background-color: @primary-opacity-10;width:100%;}
      .anticon {color: @primary;}
    }
  }
</style>
